import React from 'react'

const Saturn: React.FC = () => {
    return (
        <svg
            width="110"
            height="92"
            viewBox="0 0 110 92"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M46.425 29.1597C16.5023 43.5884 -3.99265 63.8051 0.658135 74.3257C5.29316 84.8463 33.3082 81.6802 63.2151 67.2515C93.1221 52.8228 113.617 32.5896 108.982 22.0855C104.347 11.5814 76.3319 14.731 46.425 29.1597ZM61.1814 62.6343C35.0109 75.2491 10.7322 78.5141 6.94852 69.9394C3.16483 61.3481 21.3108 44.1821 47.4655 31.5673C73.6203 18.9524 97.899 15.671 101.698 24.2457C105.498 32.8205 87.3362 50.003 61.1814 62.6343Z"
                fill="#E0E0E0"
            />
            <path
                d="M89.6896 57.6068C95.994 39.1423 86.7939 18.8282 69.1406 12.2341C51.4874 5.64008 32.066 15.263 25.7617 33.7276C19.4573 52.1922 28.6574 72.5062 46.3107 79.1003C63.9639 85.6943 83.3853 76.0714 89.6896 57.6068Z"
                fill="#E6E6E6"
            />
            <g opacity="0.2">
                <path
                    d="M85.8075 65.6025C78.8865 76.3045 66.9521 82.2079 54.6551 81.0206C51.3444 80.7238 48.0967 79.8828 45.0225 78.5471C55.8533 77.8051 71.7921 75.8923 85.8075 65.6025Z"
                    fill="#FAFAFA"
                />
                <path
                    d="M58.3915 38.724C65.6278 35.8053 80.2739 32.3919 86.848 27.4944C87.1476 27.9561 87.4156 28.4343 87.6521 28.9455C83.9945 31.5839 80.5734 34.5686 77.4203 37.8501C70.1525 44.7923 66.5107 51.1904 54.4344 51.6851C42.3581 52.1798 50.3354 42.0055 58.3915 38.724Z"
                    fill="#FAFAFA"
                />
                <path
                    d="M37.1084 73.8642C47.7343 72.4625 73.3845 67.6805 90.9472 53.1858C90.6634 54.4555 90.3323 55.6758 89.9539 56.9455C78.8078 62.8819 58.0606 74.3589 40.561 76.2552C39.3628 75.5297 38.212 74.7382 37.1084 73.8642Z"
                    fill="#FAFAFA"
                />
                <path
                    d="M29.0029 64.498C35.8766 63.4921 42.6873 62.008 49.3718 60.0457C63.0404 55.7748 82.0534 45.683 90.819 37.8008C91.2762 39.829 91.5442 41.8903 91.6072 43.968C80.6818 51.6194 54.2591 68.4391 32.2821 69.0327C31.0682 67.6311 29.9646 66.114 29.0029 64.498Z"
                    fill="#FAFAFA"
                />
                <path
                    d="M28.501 27.7583C28.9582 26.8348 29.4784 25.9609 30.0775 25.1364C40.325 21.9538 60.0633 17.0233 69.0495 12.2412C70.4053 12.7194 71.7296 13.3131 73.0066 14.0056C61.7974 16.677 38.5593 25.2848 28.501 27.7583Z"
                    fill="#FAFAFA"
                />
                <path
                    d="M25.8679 33.4476C33.6402 30.8093 41.6964 29.1438 49.8628 28.4842C55.3492 28.4842 71.6033 21.8057 77.3419 16.6938C77.7991 17.0072 78.2247 17.3534 78.6346 17.7327C64.5561 23.9329 47.4034 39.2686 39.4892 43.7044C34.6019 46.4912 29.4782 48.7833 24.181 50.5312C23.7869 47.8434 23.7081 45.106 23.9445 42.3852C24.1968 39.351 24.8589 36.3334 25.8679 33.4476Z"
                    fill="#FAFAFA"
                />
            </g>
            <path
                d="M24.6025 53.2018C27.0777 52.5916 29.5213 51.8496 31.9177 50.9756C41.2035 47.6776 57.9621 33.5128 72.7973 26.9992C78.3625 24.5752 81.5628 23.1736 83.4232 22.415C83.9907 23.1241 84.5425 23.8332 85.0628 24.6412C80.8219 27.2301 76.4076 29.5387 71.8829 31.534C62.4394 35.673 52.3496 41.2795 46.5479 46.342C42.1021 50.1841 30.8772 55.2465 25.6431 57.1099C25.2016 55.8402 24.8548 54.521 24.6025 53.2018Z"
                fill="#E0E0E0"
            />
            <path
                d="M26.4971 59.4684C35.0419 57.2587 43.7129 55.5767 52.4626 54.4719C67.1717 52.691 72.7527 45.8642 78.7751 39.3671C81.7705 36.3 85.1916 33.744 88.9437 31.7817C89.4955 33.0844 89.9685 34.4531 90.3311 35.8218C83.5677 41.7087 76.0949 46.6722 68.1019 50.5638C54.1653 57.3906 34.8212 60.7051 27.5691 61.7934C27.1435 61.0679 26.7966 60.2764 26.4971 59.4684Z"
                fill="#E0E0E0"
            />
            <path
                d="M34.1777 71.1432C46.9319 69.4282 59.3393 65.5366 70.8953 59.6497C80.3545 54.7852 87.1021 50.9265 91.5795 48.2551C91.5952 48.4695 91.5952 48.7004 91.5795 48.9147C91.4691 49.9536 91.3745 50.9595 91.1696 51.9654C80.5437 57.9017 55.9497 70.1538 34.4773 71.407C34.3512 71.3905 34.2566 71.2586 34.1777 71.1432Z"
                fill="#E0E0E0"
            />
            <path
                d="M33.0713 21.2775C40.2445 13.3624 50.492 9.33882 60.8656 10.3282C61.6697 10.3282 62.5052 10.5261 63.2935 10.658C56.0572 14.1869 42.6409 19.9254 33.0713 21.2775Z"
                fill="#F0F0F0"
            />
            <path
                d="M43.1279 77.6735C51.6412 75.5628 73.3659 69.8408 82.6202 64.5475C84.3386 63.5251 86.1043 62.6346 87.9331 61.8596C87.3971 63.0139 86.7823 64.1352 86.0886 65.1906C79.4829 68.2083 66.6972 73.7489 59.4924 74.9691C53.1074 76.041 47.4161 77.1953 43.995 78.0527C43.6797 77.9703 43.3959 77.8384 43.1279 77.6735Z"
                fill="#E0E0E0"
            />
            <path
                d="M71.8389 16.8254C71.8389 16.8254 59.4 24.8725 53.8033 25.8619C50.4137 26.4721 46.9769 26.8019 43.54 26.8678C43.54 26.8678 61.5283 17.2047 71.8389 16.8254Z"
                fill="#E0E0E0"
            />
            <path
                d="M97.9295 20.8157C99.5691 21.4424 100.925 22.6956 101.697 24.3281C105.481 32.9194 87.3351 50.1019 61.1804 62.7167C35.0256 75.3315 10.7312 78.5965 6.94748 70.0218C6.31686 68.3563 6.31686 66.4929 6.94748 64.8109L0.546738 67.8946C-0.178469 70.0218 -0.131173 72.3468 0.688626 74.4246C5.32365 84.9452 33.3387 81.7791 63.2456 67.3504C93.1526 52.9217 113.648 32.6885 109.013 22.1844C108.035 20.1726 106.38 18.6226 104.362 17.8311L97.9295 20.8157Z"
                fill="#E0E0E0"
            />
        </svg>
    )
}

export default Saturn
